import Axios from "../../../axios";
import {paymentConstants, schoolConstants} from "../../../constants/ApiConstant";


export async function fetchSchoolDetail(id) {
    return Axios.get(schoolConstants.SCHOOL_DETAIL + `/${id}`);
}

export async function fetchSchoolMetaDetail(id) {
    return Axios.get(schoolConstants.SCHOOL_META_DETAIL + `/${id}`);
}

// Update a school's meta. `schoolId` is used in the path; the body also carries
// schoolId and the meta record id.
export async function updateSchoolMeta(schoolId, params) {
    return Axios.put(schoolConstants.SCHOOL_META_UPDATE + `/${schoolId}`, params);
}

// Record a payment for a school. The body carries schoolId along with the
// amount/discount/vat/years/remarks captured in the Add Payment modal.
export async function savePayment(params) {
    return Axios.post(paymentConstants.PAYMENT_SAVE, params);
}

// List payments for a school (optionally filtered by date range / search).
export async function searchPayment(params) {
    return Axios.post(paymentConstants.PAYMENT_SEARCH, params);
}